const common = require('./config.common');

const config = {
    build: {
        entryPublicPath: 'https://components2.corriereobjects.it',
        env: 'prod',
    },
    linkUrlParamListener: {
        enabled: true,
        params: ['app_v2', 'app_name'],
    },
};

Object.assign(config, common);
module.exports = config;
